/* ============================================================
   BNE STUDIO — shared footer
   Ported from the design handoff (chrome.js FOOTER). Links to
   `active` highlights the current page's link.
   ============================================================ */
import React from "react";
import { Link } from "react-router-dom";
import { NightIcon } from "./icons";

const DIST = "/distribute";

const COLUMNS = [
  {
    title: "Create",
    links: [
      ["/sync", "Sync"],
      ["/vision", "Vision"],
      ["/tools#stem-separator", "Stem Separator"],
      ["/tools#mix-feedback", "Mix Feedback"],
      ["/tools#music-suite", "Music Suite"],
    ],
  },
  {
    title: "Release & Promote",
    links: [
      [DIST, "Distribution"],
      ["/contracts", "Contracts"],
      ["/tools#smart-links", "Smart Links"],
      ["/vision", "Vision Reels"],
      ["/tools#lyrics", "Lyrics"],
    ],
  },
  {
    title: "Perform & Tools",
    links: [
      ["/live", "BNE Live"],
      ["/tools", "All Tools"],
      ["/tools#bpm-finder", "BPM Finder"],
      ["/tools#pitch-shifter", "Pitch Shifter"],
      ["/tools#tap-tempo", "Tap Tempo"],
    ],
  },
  {
    title: "Company",
    links: [
      ["/home", "About"],
      ["/contact-us", "Contact"],
      ["https://dashboard.bne.studio", "Support"],
      ["/privacy", "Privacy"],
      ["/terms", "Terms"],
      ["/distribution-agreement", "Distribution Agreement"],
    ],
  },
];

// active key -> the footer link that should get the .on highlight
const ACTIVE_HREF = {
  dist: DIST,
  sync: "/sync",
  vision: "/vision",
  contracts: "/contracts",
  live: "/live",
  tools: "/tools",
};

function FootLink({ href, label, on }) {
  const cls = on ? "on" : undefined;
  if (href.charAt(0) === "/") {
    return (
      <Link to={href} className={cls}>
        {label}
      </Link>
    );
  }
  return (
    <a href={href} className={cls}>
      {label}
    </a>
  );
}

export default function NightFooter({ active = "" }) {
  const currentHref = ACTIVE_HREF[active] || null;

  return (
    <footer className="footer">
      <div className="wrap">
        <div className="foot-grid">
          <div>
            <Link className="brand brand-lockup" to="/home" aria-label="BNE Studio home">
              <span className="mark">
                <NightIcon name="logo" />
              </span>
            </Link>
            <p className="desc">
              Upload one song. Get a worldwide release, unlimited videos, and a
              sold-out tour.
            </p>
            <div className="foot-social">
              <a href="#" aria-label="Instagram">
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none">
                  <rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" strokeWidth="1.8" />
                  <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="1.8" />
                  <circle cx="17.5" cy="6.5" r="1" fill="currentColor" />
                </svg>
              </a>
              <a href="#" aria-label="X">
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none">
                  <path d="M4 4l16 16M20 4L4 20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                </svg>
              </a>
              <a href="#" aria-label="YouTube">
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none">
                  <rect x="3" y="6" width="18" height="12" rx="3" stroke="currentColor" strokeWidth="1.8" />
                  <path d="M11 9.5l3.5 2.5L11 14.5z" fill="currentColor" />
                </svg>
              </a>
            </div>
          </div>

          {COLUMNS.map((col) => (
            <div className="fcol" key={col.title}>
              <h5>{col.title}</h5>
              {col.links.map(([href, label]) => (
                <FootLink
                  key={label}
                  href={href}
                  label={label}
                  on={currentHref != null && href === currentHref}
                />
              ))}
            </div>
          ))}
        </div>

        <div className="foot-bot">
          <span>© 2026 BNE Studio. All rights reserved.</span>
          <div className="legal">
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
            <Link to="/distribution-agreement">Distribution Agreement</Link>
            <Link to="/contact-us">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
